import type * as React from 'react';

import { cn } from '@/utils/ui-utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = ({ className, ...props }: TextareaProps & React.ComponentProps<'textarea'>) => {
  return (
    <textarea
      className={cn(
        `border-input bg-muted placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[60px] w-full
        rounded-md border px-3 py-2 text-base shadow-2xs focus-visible:ring-1 focus-visible:outline-hidden
        disabled:cursor-not-allowed disabled:opacity-50`,
        className,
      )}
      {...props}
    />
  );
};
Textarea.displayName = 'Textarea';

export { Textarea };
